/**
 * @file
 */

export default (Drupal, once) => {

  // tabled
  // https://github.com/Lullabot/tabled
  Drupal.behaviors.responsiveTables = {
    attach (context) {
      once('responsive-table', 'table', context).forEach(function () {
        (function () {
          const tables = document.querySelectorAll('table')

          tables.forEach((table) => {
            new Tabled({ table: table, failClass: 'tabled--stacked' })
          })
        })()
      })
    }
  }
}
